export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6698.214a4b3f.jpg";